var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useDefaultApiParams } from 'src/hooks';
// @ts-expect-error: queryKey has type any
export function getProductDetails(_a) {
    return __awaiter(this, arguments, void 0, function* ({ signal, queryKey }) {
        const [_key, asin, defaultApiParams] = queryKey;
        return yield HandshakePainterServiceApiV1.getProductDetails({
            asin,
            xJoinId: defaultApiParams.xJoinId,
            xUserLinked: defaultApiParams.xUserLinked,
            marketplaceId: defaultApiParams.marketplaceId,
        }, 
        // This allows the query to be aborted/cancelled
        { signal });
    });
}
export const useProductDetails = () => {
    const { asin } = useParams();
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    return useQuery({
        queryKey: ['getProductDetails', asin, defaultApiParams],
        queryFn: getProductDetails,
        enabled: !!asin,
        // Data stays fresh for 30 seconds to allow for caching between product selections
        // TODO: Move away from this approach since AmazonAPI usually says not to add an additional cache
        // on top of theirs. The risk being that we show outdated offer info for 1 min
        staleTime: 1 * 30 * 1000,
    });
};
